(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4334],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 46858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/dealership-enquiry",
      function () {
        return __webpack_require__(30148);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={} , analyticsEvent , analyticsData  } = props;
    const isHomePage = (url)=>{
        return !url || url === _constants_index__WEBPACK_IMPORTED_MODULE_5__.HOMEPAGEURL ? "/" : url;
    };
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url));
        setShortURLs(urls);
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).map((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        let path = "";
        for(let i = 0; i < index; i++){
            var ref;
            path += "".concat((ref = items[i].title) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ");
        }
        if (!isSsr) {
            var ref1;
            let eventInfo = {
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: path + (navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                internalLinkPosition: eventPageName,
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url) : "n/a",
                internalLinkZoneName: eventPageName + ":" + zone
            };
            if (analyticsData) {
                eventInfo = {
                    ...eventInfo,
                    ...analyticsData
                };
            }
            return JSON.stringify(eventInfo);
        }
    };
    const handleClick = (navItem)=>{
        if (analyticsEvent) {
            analyticsEvent(navItem);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
        children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            id: "breadcrumb",
            className: "cmp-breadcrumb",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "cmp-breadcrumb__list",
                itemScope: true,
                itemType: ITEM_TYPE.breadcrumbList,
                children: items.map((navItem, index)=>{
                    const isLastItem = index === items.length - 1;
                    const isActive = navItem.active;
                    const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "cmp-breadcrumb__item",
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: ITEM_TYPE.listItem,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isHomePage(shortURLs[index]),
                                className: "cmp-breadcrumb__item-link",
                                itemProp: "item",
                                "data-zone": zone,
                                "aria-label": navItem.title,
                                "aria-current": navItem.active ? "page" : null,
                                "data-gbh-data-layer": !analyticsEvent && !isSsr ? getEventInfo(navItem, index) : null,
                                onClick: ()=>handleClick(navItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    itemProp: "name",
                                    dangerouslySetInnerHTML: {
                                        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                    }
                                })
                            }),
                            shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cmp-breadcrumb-slash",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                itemProp: "position",
                                content: index + 1
                            })
                        ]
                    }, "breadcrumb-item-".concat(index));
                })
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 30148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dealership_enquiry; },
  "getServerSideProps": function() { return /* binding */ getServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/serverSideTranslations.js
var serverSideTranslations = __webpack_require__(55709);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 98 modules
var AemGrid = __webpack_require__(72960);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./public/icons/edit.svg
var edit = __webpack_require__(62617);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/TextArea/TextArea.jsx
var TextArea = __webpack_require__(29707);
// EXTERNAL MODULE: ./components/Shared/Otp/v1/index.jsx + 1 modules
var v1 = __webpack_require__(30834);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./utils/constants.js
var utils_constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./components/core/Autocomplete/Autocomplete.jsx
var Autocomplete = __webpack_require__(81511);
// EXTERNAL MODULE: ./utils/enquiry.js
var enquiry = __webpack_require__(55754);
;// CONCATENATED MODULE: ./components/DealershipEnquiry/analytics.js

const pageType = "dealership enquiry";
const componentType = "dealership enquiry";
const breadcrumbAnalytics = (navItem)=>{
    const link = (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + navItem.url : "n/a";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":hero banner:breadcrumb"),
        eventName: "".concat(pageType, ":hero banner:breadcrumb"),
        eventType: "navigation",
        internalLinkName: "home",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":breadcrumb"),
        internalLinkZoneName: "".concat(pageType, ":hero banner"),
        internalLinkURL: link !== null && link !== void 0 ? link : "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getOtpAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":form:get otp"),
        eventName: "".concat(pageType, ":form:get otp"),
        eventType: "navigation",
        internalLinkName: "get otp",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const editMobileAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":form:mobile number:edit"),
        eventName: "".concat(pageType, ":form:mobile number:edit"),
        eventType: "navigation",
        internalLinkName: "edit",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType),
        internalLinkZoneName: "".concat(pageType, ":form:mobile number"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const submitEnquiryAnalytics = (payload, status, statusMsg)=>{
    var ref, ref1, ref2;
    var ref3, ref4, ref5;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":form:submit"),
        eventName: "".concat(pageType, ":form:submit"),
        eventStatus: status,
        eventMsg: statusMsg !== null && statusMsg !== void 0 ? statusMsg : "n/a",
        eventType: "navigation",
        internalLinkName: "submit",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":form"),
        internalLinkURL: "n/a",
        selectedCity: (ref3 = payload === null || payload === void 0 ? void 0 : (ref = payload.city) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : "",
        selectedSpaceAvailable: (ref4 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.spaceAvailable) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref4 !== void 0 ? ref4 : "",
        selectedBudget: (ref5 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.budget) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) !== null && ref5 !== void 0 ? ref5 : ""
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const cancelEnquiryAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":form:cancel"),
        eventName: "".concat(pageType, ":form:cancel"),
        eventType: "navigation",
        internalLinkName: "cancel",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const backToHomeAnalytics = (link)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":main content area:back to homepage"),
        eventName: "".concat(pageType, ":main content area:back to homepage"),
        eventType: "navigation",
        internalLinkName: "back to homepage",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ": main content area"),
        internalLinkURL: link
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const privacyStatementAnalytics = (text, link)=>{
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "".concat(pageType, ":form:").concat(text),
        eventName: "".concat(pageType, ":form:").concat(text),
        eventType: "navigation",
        internalLinkName: text,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":form"),
        internalLinkURL: link
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/DealershipEnquiry/Form/DealershipEnquiry.jsx






















const DealershipEnquiry = (props)=>{
    var ref, ref1, ref2, ref3;
    const { staticText , setConfirmationSuccess  } = props;
    const { authModal: { staticTextPopup  } = {} , isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [verifiedMobileNumber, setVerifiedMobileNumber] = (0,react.useState)(false);
    const [data, setData] = (0,react.useState)({});
    const [error, setError] = (0,react.useState)({});
    const [verifyOTP, setVerifyOTP] = (0,react.useState)(false);
    const [changeNumber, setChangeNumber] = (0,react.useState)(false);
    const [count, setCount] = (0,react.useState)(0);
    const [userDetails, setUserDetails] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        if (isAuth) {
            const number = localStorage.getItem("numberAlreadyExists");
            setVerifiedMobileNumber(true);
            localStorage.removeItem("numberAlreadyExists");
            let dataInitialValue = {
                firstName: get_default()(user, "firstName", ""),
                phone: get_default()(user, "login", ""),
                lastName: get_default()(user, "lastName", ""),
                email: get_default()(user, "sub", ""),
                alternativePhone: ""
            };
            setData(dataInitialValue);
            setError({
                ...error,
                phone: ""
            });
        }
    }, [
        isAuth,
        user,
        verifiedMobileNumber
    ]);
    const termsRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        // to add analytics for privacy statement link
        const elem = termsRef.current.querySelectorAll("a");
        if (elem[0]) {
            elem[0].addEventListener("click", ()=>{
                var ref;
                return privacyStatementAnalytics((ref = elem[0].innerText) === null || ref === void 0 ? void 0 : ref.toLowerCase(), elem[0].getAttribute("href"));
            });
        }
    }, []);
    const handleChangeNumber = (event)=>{
        const { value  } = event.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                phone: value
            });
            setError({
                ...error,
                phone: ""
            });
        }
    };
    const onChangeAlternatePhone = (e)=>{
        const { value  } = e.target;
        const getValue = value.replace(/[^\d]/g, "");
        setData({
            ...data,
            alternativePhone: getValue
        });
    };
    const onNameChange = (e)=>{
        const { name , value  } = e.target;
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                [name]: value
            });
            setError({
                ...error,
                [name]: ""
            });
        }
    };
    const onChangeEmail = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            email: value
        });
        if (value) {
            if ((0,validate/* validateEmail */.oH)(value)) {
                setError({
                    ...error,
                    email: null
                });
            } else {
                setError({
                    ...error,
                    email: staticText.emailAddressError
                });
            }
        }
    };
    const handleCityChange = (value)=>{
        var ref;
        setData({
            ...data,
            city: value
        });
        const cities = (ref = staticText.cities) === null || ref === void 0 ? void 0 : ref.map((ele)=>ele.text);
        if (!value || value === "" || !cities.includes(value)) {
            setError({
                ...error,
                city: staticText.cityError
            });
        } else setError({
            ...error,
            city: ""
        });
    };
    const handleSpaceAvailableOptionChange = (value)=>{
        setData({
            ...data,
            spaceAvailableOption: value
        });
        if (value === "") {
            setError({
                ...error,
                spaceAvailableOption: staticText.spaceAvailableError
            });
        } else {
            setError({
                ...error,
                spaceAvailableOption: ""
            });
        }
    };
    const handleBudgetOptionChange = (value)=>{
        setData({
            ...data,
            budgetOption: value
        });
        if (value === "") {
            setError({
                ...error,
                budgetOption: staticText.budgetError
            });
        } else {
            setError({
                ...error,
                budgetOption: ""
            });
        }
    };
    const isValidNumber = constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone);
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const validateExist = (field)=>{
        if (field === "firstName" || field === "lastName" || field === "company") {
            var ref;
            if (!((ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", data[field])) {
                switch(field){
                    case "firstName":
                        return staticText === null || staticText === void 0 ? void 0 : staticText.firstNameError;
                    case "lastName":
                        return staticText === null || staticText === void 0 ? void 0 : staticText.lastNameError;
                    case "company":
                        return staticText === null || staticText === void 0 ? void 0 : staticText.companyError;
                    default:
                        return "";
                }
            }
        } else if (field === "phone") {
            var ref1;
            if (!(data === null || data === void 0 ? void 0 : (ref1 = data.phone) === null || ref1 === void 0 ? void 0 : ref1.trim()) || !constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone)) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorMobileNumber;
            }
        } else if (field === "email") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.noEmailError;
            } else if (!(0,helper.validateField)("email", data[field]) || !(0,validate/* validateEmail */.oH)(data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.emailAddressError;
            } else {
                return "";
            }
        } else if (field === "spaceAvailableOption") {
            var ref2;
            const spaceAvailableItems = (ref2 = staticText.spaceAvailableItems) === null || ref2 === void 0 ? void 0 : ref2.map((ele)=>ele.spaceAvailable);
            if (!data[field] || data[field] === "" || !spaceAvailableItems.includes(data[field])) return staticText.spaceAvailableError;
        } else if (field === "budgetOption") {
            var ref3;
            const budgetItems = (ref3 = staticText.budgetItems) === null || ref3 === void 0 ? void 0 : ref3.map((ele)=>ele.budget);
            if (!data[field] || data[field] === "" || !budgetItems.includes(data[field])) return staticText.budgetError;
        } else if (field === "city") {
            var ref4;
            const cities = (ref4 = staticText.cities) === null || ref4 === void 0 ? void 0 : ref4.map((ele)=>ele.text);
            if (!data[field] || data[field] === "" || !cities.includes(data[field])) return staticText.cityError;
        }
    };
    const submitDealership = async (payload1)=>{
        var ref;
        let accessToken = null;
        accessToken = (ref = (0,helper.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
        return new Promise(async (resolve, reject)=>{
            try {
                const { data: content  } = await api/* apim.post */.TH.post("".concat(constants.apiBaseUrl).concat(utils_constants/* submitDealershipUrl */.Bp), payload1);
                resolve(content);
            } catch (error) {
                reject(error);
            }
        });
    };
    const scrollToTop = ()=>{
        document.querySelector("body").scrollIntoView({
            top: 0,
            behavior: "smooth"
        });
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        let errorDataList = [];
        setError(errorList);
        for(const key in errorList){
            errorDataList.push(errorList[key]);
        }
        errorDataList.map((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { firstName , lastName , email , company , spaceAvailableOption , budgetOption , city , dealershipDescription , phone  } = data;
            const payload1 = {
                ...{
                    firstName: firstName === null || firstName === void 0 ? void 0 : firstName.trim(),
                    lastName: lastName === null || lastName === void 0 ? void 0 : lastName.trim(),
                    email,
                    company,
                    spaceAvailable: spaceAvailableOption,
                    budget: budgetOption,
                    city,
                    description: dealershipDescription !== null && dealershipDescription !== void 0 ? dealershipDescription : "",
                    mobile: phone,
                    enquiryType: "dealership-enquiry"
                }
            };
            const response = await submitDealership(payload1);
            if (response.statusCode === 200) {
                submitEnquiryAnalytics(payload1, "success");
                setConfirmationSuccess(true);
                (0,helper.setBannerConfirmationText)(staticText.dealershipBannerText, "enquiry-form-banner");
                scrollToTop();
            } else {
                submitEnquiryAnalytics(payload1, "failure", "form submission failed");
                setConfirmationSuccess(false);
                scrollToTop();
            }
        } else {
            submitEnquiryAnalytics(payload, "failure", "form validation failed");
        }
    };
    const handleResetData = ()=>{
        setData({});
        setError({});
        setVerifiedMobileNumber(false);
        scrollToTop();
        cancelEnquiryAnalytics();
    };
    const getErrorList = ()=>{
        const errorList = {
            firstName: validateExist("firstName"),
            lastName: validateExist("lastName"),
            company: validateExist("company"),
            email: validateExist("email"),
            spaceAvailableOption: validateExist("spaceAvailableOption"),
            budgetOption: validateExist("budgetOption"),
            city: validateExist("city")
        };
        return errorList;
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) || !verifiedMobileNumber ? true : false;
    const changeNumberHandler = async ()=>{
        setVerifyOTP(true);
        setChangeNumber(true);
        editMobileAnalytics();
    };
    const getOTP = async ()=>{
        let { numberExists , factorId , userId  } = await (0,enquiry/* checkNumberExists */.gU)(data === null || data === void 0 ? void 0 : data.phone);
        const isBrandOrTransact = (0,utils/* isBrandTransact */.AY)();
        if (!isBrandOrTransact && numberExists && !isAuth) {
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            if (isValidNumber) {
                setUserDetails({
                    factorId: factorId,
                    userId: userId
                });
                setVerifyOTP(true);
                setChangeNumber(false);
            } else {
                setVerifyOTP(false);
            }
        }
        getOtpAnalytics();
    };
    const verifiedNumber = ()=>{
        setVerifiedMobileNumber(true);
        setVerifyOTP(false);
    };
    const setPhoneNumber = (phone)=>{
        setData({
            ...data,
            phone: phone
        });
    };
    var _phone, ref4, ref5, ref6, _city, _spaceAvailableOption, _budgetOption, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dealership-enquiry__margin-div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dealership-enquiry__title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "dealership-enquiry__question",
                        children: staticText.dealershipTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "dealership-enquiry__required-fields",
                        children: staticText.dealershipFormDescription
                    })
                ]
            }),
            !verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dealership-enquiry__phoneDiv flex-mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dealership-enquiry__countryIcon country-code",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "",
                            id: "contact-user-country-code",
                            type: "text",
                            disabled: true,
                            value: "+91"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dealership-enquiry__phoneNumber phone-number",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            disabled: verifiedMobileNumber,
                            customClass: "customer-support-inputfield",
                            id: "contact-user-phone",
                            type: "text",
                            value: (_phone = data.phone) !== null && _phone !== void 0 ? _phone : "",
                            maxLength: 10,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            onChange: handleChangeNumber,
                            showError: error === null || error === void 0 ? void 0 : error.phone,
                            errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                            onBlur: ()=>onBlur("phone")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: getOTP,
                        style: isValidNumber ? {
                            cursor: "pointer"
                        } : {
                            cursor: "not-allowed"
                        },
                        className: "dealership-enquiry__getOTPLink ".concat(isValidNumber && "--active"),
                        children: staticText === null || staticText === void 0 ? void 0 : staticText.dealershipEnquiryGetOtpLabel
                    })
                ]
            }),
            verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    customClass: isAuth ? "dealership-enquiry__phoneDivDisabled non-editable" : "dealership-enquiry__phoneDivDisabled",
                    type: "text",
                    disabled: true,
                    value: "+91 ".concat(data === null || data === void 0 ? void 0 : data.phone),
                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                    label: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                    suffix: verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: edit/* default */.Z === null || edit/* default */.Z === void 0 ? void 0 : edit/* default.src */.Z.src,
                        alt: "",
                        "aria-hidden": "true",
                        onClick: changeNumberHandler,
                        style: {
                            cursor: "pointer"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(!verifiedMobileNumber && isValidNumber ? "dealership-enquiry__verifyNumberText --error" : "dealership-enquiry__verifyNumberText"),
                children: !verifiedMobileNumber ? staticText === null || staticText === void 0 ? void 0 : staticText.verifyMobile : staticText === null || staticText === void 0 ? void 0 : staticText.mobileVerified
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 pr-10 m-pr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-fname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref4 = data === null || data === void 0 ? void 0 : data.firstName) !== null && ref4 !== void 0 ? ref4 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            onChange: onNameChange,
                            onInput: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.firstName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.firstName,
                            onBlur: ()=>onBlur("firstName"),
                            name: "firstName"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-10 pr-0 m-pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-lname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref5 = data === null || data === void 0 ? void 0 : data.lastName) !== null && ref5 !== void 0 ? ref5 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            onChange: onNameChange,
                            onInput: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.lastName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.lastName,
                            onBlur: ()=>onBlur("lastName"),
                            name: "lastName"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-email",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.emailAddress,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.emailAddress,
                value: (ref6 = data === null || data === void 0 ? void 0 : data.email) !== null && ref6 !== void 0 ? ref6 : "",
                maxLength: 60,
                autoComplete: true,
                onChange: onChangeEmail,
                onInput: onChangeEmail,
                showError: (error === null || error === void 0 ? void 0 : error.email) !== "" && (error === null || error === void 0 ? void 0 : error.email),
                errorMessage: error === null || error === void 0 ? void 0 : error.email,
                onBlur: ()=>onBlur("email")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dealership-enquiry__phoneDiv flex-mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dealership-enquiry__countryIcon country-code",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "",
                            id: "contact-user-country-code",
                            type: "text",
                            disabled: true,
                            value: "+91"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dealership-enquiry__alternativephoneNumber",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "customer-support-inputfield",
                            id: "contact-user-alternativephone",
                            type: "text",
                            value: data.alternativePhone,
                            maxLength: 10,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumber,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumber,
                            onChange: onChangeAlternatePhone
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                    label: staticText.city,
                    data: (ref1 = staticText.cities) === null || ref1 === void 0 ? void 0 : ref1.map((ele)=>({
                            name: ele.text
                        })),
                    id: "contact-user-city",
                    name: "city",
                    value: (_city = data.city) !== null && _city !== void 0 ? _city : "",
                    onChange: handleCityChange,
                    onBlur: ()=>onBlur("city"),
                    errorMessage: error === null || error === void 0 ? void 0 : error.city,
                    showError: !error.city || error.city === "" ? false : true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                    label: staticText.spaceAvailable,
                    data: (ref2 = staticText.spaceAvailableItems) === null || ref2 === void 0 ? void 0 : ref2.map((ele)=>({
                            name: ele.spaceAvailable
                        })),
                    id: "contact-user-space-available",
                    name: "spaceAvailableOption",
                    value: (_spaceAvailableOption = data.spaceAvailableOption) !== null && _spaceAvailableOption !== void 0 ? _spaceAvailableOption : "",
                    onChange: handleSpaceAvailableOptionChange,
                    showError: !error.spaceAvailableOption || error.spaceAvailableOption === "" ? false : true,
                    errorMessage: error === null || error === void 0 ? void 0 : error.spaceAvailableOption,
                    onBlur: ()=>onBlur("spaceAvailableOption")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                    label: staticText.budget,
                    data: (ref3 = staticText.budgetItems) === null || ref3 === void 0 ? void 0 : ref3.map((ele)=>({
                            name: ele.budget
                        })),
                    id: "contact-user-budget",
                    name: "budgetOption",
                    value: (_budgetOption = data.budgetOption) !== null && _budgetOption !== void 0 ? _budgetOption : "",
                    onChange: handleBudgetOptionChange,
                    showError: !error.budgetOption || error.budgetOption === "" ? false : true,
                    errorMessage: error === null || error === void 0 ? void 0 : error.budgetOption,
                    onBlur: ()=>onBlur("budgetOption")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-company-name",
                type: "text",
                customClass: "customer-support-inputfield",
                value: (ref7 = data === null || data === void 0 ? void 0 : data.company) !== null && ref7 !== void 0 ? ref7 : "",
                maxLength: 40,
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.company,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.company,
                onChange: onNameChange,
                onInput: onNameChange,
                showError: error === null || error === void 0 ? void 0 : error.company,
                errorMessage: error === null || error === void 0 ? void 0 : error.company,
                onBlur: ()=>onBlur("company"),
                name: "company"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dealership-enquiry__remarksDiv pt-25 pb-40 mt-30",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dealership-enquiry__remark-note mb-25",
                        children: staticText.dealershipSubDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dealership-enquiry__textarea_wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.describeYourRequest,
                                placeholder: "",
                                value: (ref8 = data === null || data === void 0 ? void 0 : data.dealershipDescription) !== null && ref8 !== void 0 ? ref8 : "",
                                className: "dealership-enquiry__textarea",
                                maxLength: "500",
                                onChange: (e)=>{
                                    const { value  } = e.target;
                                    setData({
                                        ...data,
                                        dealershipDescription: value
                                    });
                                    setCount(e.target.value.length);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "dealership-enquiry__textarea_placeholder",
                                children: [
                                    count,
                                    "/500"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dealership-enquiry__remark-enquiry mb-30 mt-30",
                ref: termsRef,
                children: staticText.dealershipPrivacyPolicyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dealership-enquiry__buttonDiv",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        role: "button",
                        label: staticText.submit,
                        className: "dealership-enquiry__button",
                        flexible: true,
                        onClick: ()=>handleSubmit(),
                        disabled: isEnabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "dealership-enquiry__button",
                        type: "ghost",
                        role: "button",
                        label: staticText.cancel,
                        flexible: true,
                        onClick: ()=>handleResetData()
                    })
                ]
            }),
            verifyOTP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1/* default */.Z, {
                handleClose: ()=>setVerifyOTP(false),
                showModal: verifyOTP,
                staticTexts: staticText,
                mobile: data === null || data === void 0 ? void 0 : data.phone,
                verifiedNumber: verifiedNumber,
                changeMobileNumber: changeNumber,
                setDataEnquiry: (phoneNumber)=>setPhoneNumber(phoneNumber),
                userDetails: userDetails,
                page: "dealership enquiry"
            }) : null
        ]
    });
};
/* harmony default export */ var Form_DealershipEnquiry = (DealershipEnquiry);

// EXTERNAL MODULE: ./components/DealershipEnquiry/DealershipEnquiryView/index.module.scss
var index_module = __webpack_require__(26090);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/DealershipEnquiry/Confirmation.jsx




const Confirmation = (props)=>{
    const { staticText  } = props;
    const onClick = ()=>{
        backToHomeAnalytics(window.location.href);
        window.location.href = "/";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).dealershipEnquiry,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "dealership-enquiry__success-box",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "dealership-enquiry__success-message",
                    children: staticText === null || staticText === void 0 ? void 0 : staticText.messageHeaderSuccess
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dealership-enquiry__success-description",
                    children: staticText === null || staticText === void 0 ? void 0 : staticText.dealershipConfirmationText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "kf-react-button",
                        className: "kf-react-button button large black flexible",
                        role: "button",
                        id: "submit-contact-form-button",
                        onClick: onClick,
                        type: "black",
                        label: staticText === null || staticText === void 0 ? void 0 : staticText.dealershipConfiramtionCtaLabel
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DealershipEnquiry_Confirmation = (Confirmation);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./i18n/useDealershipEnquiryi18n.js


const useDealershipEnquiry = function() {
    let authorData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1, ref2;
    const i18n = {
        dealershipTitle: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipTitle) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipTitle.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipTitle"),
        dealershipFormDescription: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipFormDescription) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipFormDescription.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipFormDescription"),
        cities: authorData === null || authorData === void 0 ? void 0 : authorData.cities,
        spaceAvailableItems: authorData === null || authorData === void 0 ? void 0 : authorData.spaceAvailableItems,
        budgetItems: authorData === null || authorData === void 0 ? void 0 : authorData.budgetItems,
        mobileNumber: t("kf.dealershipEnquiry.mobileNumber"),
        mobileNumberDescription: t("kf.dealershipEnquiry.mobileNumberDescription"),
        firstNameError: t("kf.dealershipEnquiry.firstNameError"),
        lastNameError: t("kf.dealershipEnquiry.lastNameError"),
        firstName: t("kf.dealershipEnquiry.firstName"),
        lastName: t("kf.dealershipEnquiry.lastName"),
        emailAddress: t("kf.dealershipEnquiry.emailAddress"),
        emailAddressError: t("kf.contactus.error.validEmail"),
        alternateMobileNumber: t("kf.productEnquiry.alternateMobileNumber"),
        spaceAvailable: t("kf.dealershipEnquiry.spaceAvailable"),
        spaceAvailableError: t("kf.dealershipEnquiry.spaceAvailableError"),
        budget: t("kf.dealershipEnquiry.budget"),
        budgetError: t("kf.dealershipEnquiry.budgetError"),
        city: t("kf.dealershipEnquiry.city"),
        cityError: t("kf.dealershipEnquiry.cityError"),
        company: t("kf.dealershipEnquiry.company"),
        companyError: t("kf.dealershipEnquiry.companyError"),
        submit: t("kf.dealershipEnquiry.submit"),
        cancel: t("kf.dealershipEnquiry.cancel"),
        dealershipSubDescription: t("kf.dealershipEnquiry.dealershipSubDescription"),
        dealershipPrivacyPolicyText: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipPrivacyPolicyText) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipPrivacyPolicyText.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipPrivacyPolicyText"),
        describeYourRequest: t("kf.dealershipEnquiry.describeYourRequest"),
        dealershipConfirmationText: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipConfirmationText) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipConfirmationText.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipConfirmationText"),
        dealershipConfiramtionCtaLabel: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipConfiramtionCtaLabel) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipConfiramtionCtaLabel.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipConfiramtionCtaLabel"),
        errorMobileNumber: t("kf.customerSupport.error.validMobileNumber"),
        dealershipEnquiryGetOtpLabel: (authorData === null || authorData === void 0 ? void 0 : authorData.dealershipEnquiryGetOtpLabel) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.dealershipEnquiryGetOtpLabel.replaceAll("&amp;nbsp;", " ")) : t("kf.dealershipEnquiry.dealershipEnquiryGetOtpLabel"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        verifyMobile: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.mobileDescriptionPlaceHolder) !== null && ref !== void 0 ? ref : t("kf.customerSupport.verifyMobile"),
        mobileVerified: (ref1 = authorData === null || authorData === void 0 ? void 0 : authorData.mobilerNumberOtpDescription) !== null && ref1 !== void 0 ? ref1 : t("kf.customerSupport.mobileVerified"),
        dealershipBannerText: (ref2 = authorData === null || authorData === void 0 ? void 0 : authorData.dealershipBannerText) !== null && ref2 !== void 0 ? ref2 : ""
    };
    return i18n;
};
/* harmony default export */ var useDealershipEnquiryi18n = (useDealershipEnquiry);

;// CONCATENATED MODULE: ./components/DealershipEnquiry/DealershipEnquiryView/index.jsx






const DealershipEnquiryView = (props)=>{
    const { data , citiesData  } = props;
    const authorData = {
        ...data,
        cities: citiesData
    };
    const staticText = useDealershipEnquiryi18n(authorData);
    const [confirmationSuccess, setConfirmationSuccess] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const scrollToTop = ()=>{
            window.scroll({
                top: 0,
                behavior: "smooth"
            });
        };
        scrollToTop();
    }, [
        confirmationSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).dealershipEnquiry,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "dealership-enquiry",
            children: [
                !confirmationSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_DealershipEnquiry, {
                    staticText: staticText,
                    setConfirmationSuccess: setConfirmationSuccess
                }),
                confirmationSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(DealershipEnquiry_Confirmation, {
                    staticText: staticText
                })
            ]
        })
    });
};
/* harmony default export */ var DealershipEnquiry_DealershipEnquiryView = (DealershipEnquiryView);

// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./page/dealership-enquiry.jsx
















const DealershipEnquiryPage = (param)=>{
    let { tmpData: data , citiesTmpData: citiesData , headertmp: header , footertmp: footer , globalScript , footerScript , analysticsScript , analyticsData , datalayerPageName , gbhDataLayerCustom , stateWithCities  } = param;
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data === null || data === void 0 ? void 0 : data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                        data: data,
                        fullData: fullData,
                        analyticsEvent: breadcrumbAnalytics
                    }),
                landing: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DealershipEnquiry_DealershipEnquiryView, {
                        data: data,
                        citiesData: citiesData
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */ async function getServerSideProps(param) {
    let { req , locale  } = param;
    // await i18n?.reloadResources()
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    const stateWithCitiesResult = await (0,findStore/* getStatesAndCitiesFromServer */.HR)();
    const stateWithCities = stateWithCitiesResult.result.data;
    const { data  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: constants.previewContentPrefix + constants.dealerEnquiryURL,
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(constants.dealerEnquiryURL),
        method: "GET"
    });
    const { data: citiesData  } = await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(constants.dealerEnquiryCitiesURL),
        method: "GET"
    });
    const { data: header  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : constants.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.headerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : constants.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.footerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.footerUrl, ".model.json")),
        method: "GET"
    });
    const globalScript = data === null || data === void 0 ? void 0 : data.globalScript;
    const footerScript = (data === null || data === void 0 ? void 0 : data.footerScript) ? data.footerScript : null;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) ? data === null || data === void 0 ? void 0 : data.topHeadScript : null;
    const gbhDataLayerCustom = {};
    if (data === null || data === void 0 ? void 0 : data.datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    }
    if (data === null || data === void 0 ? void 0 : data.eventPageType) {
        gbhDataLayerCustom.eventPageType = data === null || data === void 0 ? void 0 : data.eventPageType;
    }
    const analysticsScript = (data === null || data === void 0 ? void 0 : data.adobeAnalytic) || null;
    const datalayerPageName = (data === null || data === void 0 ? void 0 : data.datalayerPageName) || null;
    let tmpData = {};
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,helper.filterBackEndJson)(tmpData);
    const analyticsData = data === null || data === void 0 ? void 0 : data.data;
    const headertmp = (0,helper.filterBackEndJson)(header);
    const footertmp = (0,helper.filterBackEndJson)(footer);
    return {
        props: {
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            analyticsData,
            footerScript,
            topHeadScript,
            analysticsScript,
            gbhDataLayerCustom,
            datalayerPageName,
            stateWithCities,
            citiesTmpData: citiesData,
            ...await (0,serverSideTranslations.serverSideTranslations)(locale, [
                "common"
            ])
        }
    };
}
/* harmony default export */ var dealership_enquiry = (DealershipEnquiryPage);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 26090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dealershipEnquiry":"DealershipEnquiryView_dealershipEnquiry__zjO7S"};

/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,5709,1433,6051,9774,2888,179], function() { return __webpack_exec__(46858); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);